export const MIN_BID = 5000;
export const BID_STEP = 1000;

export type PromoPackage = {
  id: string;
  name: string;
  price: number;
  days: number;
  desc: string;
};

export const PACKAGES: Record<string, PromoPackage> = {
  sorotan: {
    id: "sorotan",
    name: "Sorotan",
    price: 25000,
    days: 7,
    desc: "Kartu disorot dengan aksen biru & label Sorotan selama 7 hari.",
  },
  pin: {
    id: "pin",
    name: "Pin Teratas",
    price: 50000,
    days: 1,
    desc: "Disematkan di puncak papan selama 24 jam penuh, di atas semua peringkat.",
  },
  boost: {
    id: "boost",
    name: "Boost 30 Hari",
    price: 150000,
    days: 30,
    desc: "Sorotan permanen 30 hari, badge Boost, dan prioritas di halaman kategori.",
  },
};

export const CATEGORIES = [
  "Jasa Digital",
  "Sebar Iklan",
  "Sosial Media",
  "Desain & Kreatif",
  "Penulisan Konten",
  "Toko Online",
  "Edukasi & Kursus",
  "Keuangan & Bisnis",
  "Properti",
  "Kuliner",
  "Event & Hiburan",
  "Lainnya",
];

export function formatIDR(value: number) {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(value);
}

export function badgesFor(listing: {
  total_amount: number;
  clicks: number;
  points: number;
  boost_until: string | null;
  highlight_until: string | null;
  pin_until: string | null;
}) {
  const now = Date.now();
  const active = (v: string | null) => !!v && new Date(v).getTime() > now;
  const badges: string[] = [];
  if (active(listing.pin_until)) badges.push("Pin");
  if (active(listing.boost_until)) badges.push("Boost");
  else if (active(listing.highlight_until)) badges.push("Sorotan");
  if (listing.total_amount > 0) badges.push("Terverifikasi");
  if (listing.clicks >= 100) badges.push("Populer");
  return badges;
}

export function levelFor(points: number) {
  if (points >= 500) return { level: 5, label: "Legenda" };
  if (points >= 250) return { level: 4, label: "Elite" };
  if (points >= 100) return { level: 3, label: "Naik Daun" };
  if (points >= 25) return { level: 2, label: "Aktif" };
  return { level: 1, label: "Pemula" };
}
